import dayjs from 'dayjs';
import { action, computed, makeObservable } from 'mobx';

import { logWithSentry, SentryErrorKind } from 'scripts/initSentry';
import { IFormFieldOptions } from 'stores/interfaces/IFormField';
import { IFormStore } from 'stores/interfaces/IFormStore';

import { FieldStore } from '../FieldStore';

type Value = Date | null;
type ToServerData = string | null;

export class FieldDateStore extends FieldStore<Value> implements IFormStore<any, ToServerData> {
  constructor(options?: Partial<IFormFieldOptions<Value>>) {
    super({ ...options, defaultValue: options?.defaultValue ?? null });

    makeObservable(this, {
      serverFormat: computed,
      setFromServerFormat: action.bound,
      serverFormatEndDay: computed,
      setFromQueryFormat: action.bound,
    });
  }

  /** Заполняет значение поле из серверных данных **/
  setFromServerFormat<T>(from: T): void {
    try {
      if (typeof from === 'string' || typeof from === 'number') {
        this.setValue(new Date(from), { noTouch: true });
      }
    } catch (e) {
      this.setValue(null, { noTouch: true });
      logWithSentry(e, SentryErrorKind.normalization);
    }
  }

  setFromQueryFormat(from: string): void {
    this.setFromServerFormat(from);
  }

  /** Значение поле в серверном формате **/
  get serverFormat(): ToServerData {
    return this.value !== null ? dayjs(this.value).format('YYYY-MM-DDTHH:mm:ss') : null;
  }

  get serverFormatEndDay(): ToServerData {
    return this.value !== null ? dayjs(this.value).endOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
  }
}
